import PropTypes from "prop-types";
import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import "./common.css";

const RMPMToggleButton = ({ options, value, onChange }) => {
  return <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(_, newValue) => onChange(newValue)}
        aria-label="toggle-graph-table"
        className="rmpm-toggle-group"
      >
        {options.map((item) => (
          <ToggleButton
            key={item.value}
            className="rmpm-toggle-btn"
            selected={value === item.value}
            sx={{
              height: 28,
              p: "0 8px",
              background: "transparent",
              border: "none",
            }}
            value={item.value}
            aria-label={`toggle-${item.value.toLowerCase()}`}
          >
            {item.title ? <Typography fontSize={14}>{item.title}</Typography> : ""}
            {item.icon ? item.icon : null}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
};

RMPMToggleButton.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      title: PropTypes.string,
      icon: PropTypes.node,
    }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default RMPMToggleButton;
